import type { FormShare, FormSubmission } from "#app/lib/forms";

import { FormAccessDialog } from "../form-access-dialog";

export function SubmissionShareDialog({
  submission,
  formName,
  onOpenChange,
  onChange,
  canRemove,
}: {
  submission: FormSubmission | null;
  formName: string;
  onOpenChange: (open: boolean) => void;
  onChange: (submissionId: string, sharedWith: FormShare[]) => void;
  /** The owner and Manage Forms take people off; anyone else who reads it only passes it on. */
  canRemove: boolean;
}) {
  return (
    <FormAccessDialog
      {...(canRemove
        ? {}
        : { keepReason: "Only the person who filled it and form managers can remove access" })}
      description={submission?.status === "inProgress" ? "Sharing unfinished filling" : "Sharing submission"}
      name={formName}
      onOpenChange={onOpenChange}
      onSharesChange={(shares) => submission && onChange(submission.submissionId, shares)}
      open={submission != null}
      shares={submission?.sharedWith ?? []}
    />
  );
}
